
export const VerificationStatuses = {
    Unknown: 0,
    Basic: 1,
    Pending: 2,
    Verified: 3
}

export const InternalApplicationStatuses = {
    Draft: 2,
    Submitted: 3,
    InProgress: 5,
    FollowUp: 6,
    Rejected: 8,
    Cancelled: 9,
    Withdrawn: 16,
    PaymentSent: 18,
    PaymentComplete: 19
}

export const StatusTransitionEventEnum = {
    None: 0,
    SubmittedToDraft: 1,
  };

export const VerificationStatusChangeEvent = {
    None: 0,
    BasicToPending: 1,
    BasicToVerified: 2,
};

export const ProgramStatuses = {
    Draft: 0,
    SoftLaunch: 1,
    Open: 2,
    Inactive: 3,
}

export const EventStatuses = {
    Draft: 0,
    Active: 1,
    Inactive: 2,
}

export const constants = {
    InternalStatus: { ...InternalApplicationStatuses},
    VerificationStatus: { ...VerificationStatuses },
    ProgramStatus: { ...ProgramStatuses },
    StatusTransitionEventEnum: { ...StatusTransitionEventEnum },
    VerificationStatusChangeEvent: { ...VerificationStatusChangeEvent },
}